/* Guest Pages */
const Guest = () => import(/* webpackChunkName: "guest" */ '@/pages/guest/Guest')
const SignIn = () => import(/* webpackChunkName: "signin" */ '@/pages/guest/SignIn')
const ForgotPassword = () => import(/* webpackChunkName: "forgot-password" */ '@/pages/guest/ForgotPassword')
const ChangePassword = () => import(/* webpackChunkName: "change-password" */ '@/pages/guest/ChangePassword')

/* Authenticated Pages */
const Auth = () => import(/* webpackChunkName: "auth" */ '@/pages/auth/Auth')
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/pages/auth/Dashboard')
const Users = () => import(/* webpackChunkName: "users" */ '@/pages/auth/Users')
const UserProfile = () => import(/* webpackChunkName: "user-profile" */ '@/pages/auth/UserProfile')
const NotificationPost = () => import(/* webpackChunkName: "notification-post" */ '@/pages/auth/NotificationPost')
const NotificationCreate = () => import(/* webpackChunkName: "create-notification" */ '@/pages/auth/NotificationCreate')
const NotificationEdit = () => import(/* webpackChunkName: "edit-notification" */ '@/pages/auth/NotificationEdit')
const NewsfeedPost = () => import(/* webpackChunkName: "newsfeed-post" */ '@/pages/auth/NewsfeedPost')
const NewsfeedCreate = () => import(/* webpackChunkName: "create-newsfeed" */ '@/pages/auth/NewsfeedCreate')
const NewsfeedEdit = () => import(/* webpackChunkName: "edit-newsfeed" */ '@/pages/auth/NewsfeedEdit')
const AddSubtags = () => import(/* webpackChunkName: "add-subtags" */ '@/pages/auth/AddSubtags')
const Orders = () => import(/* webpackChunkName: "orders" */ '@/pages/auth/Orders')
const Order = () => import(/* webpackChunkName: "orders" */ '@/pages/auth/Order')
const Stickers = () => import(/* webpackChunkName: "stickers" */ '@/pages/auth/Stickers')
const StickersView = () => import(/* webpackChunkName: "view-stickers" */ '@/pages/auth/StickersView')
const StickersAdd = () => import(/* webpackChunkName: "add-stickers" */ '@/pages/auth/StickersAdd')
const StickersUpdate = () => import(/* webpackChunkName: "stickers-update" */ '@/pages/auth/StickersUpdate')
const Messages = () => import(/* webpackChunkName: "messages" */ '@/pages/auth/Messages')

const GenerateReport = () => import(/* webpackChunkName: "generate-report" */ '@/pages/auth/GenerateReport')

export default [
	...middleware('guest', [
		{
			path: '/',
			component: Guest,

			children: [
				{
					path: '/',
					name: 'signin',
					component: SignIn
				},

				{
					path: '/forgot-password',
					name: 'forgot-password',
					component: ForgotPassword
				},

				{
					path: '/change-password',
					name: 'change-password',
					component: ChangePassword
				}
			]
		}
	]),

	...middleware('auth', [
		{
			path: '/',
			component: Auth,
			redirect: '/dashboard',

			children: [
				{
					path: '/dashboard',
					name: 'dashboard',
					component: Dashboard,
					meta: {
						title: 'Dashboard'
					}
				},

				{
					path: '/users',
					name: 'users',
					component: Users,
					meta: {
						title: 'Users'
					}
				},

				{
					path: '/user-profile/:id',
					name: 'user-profile',
					component: UserProfile,
					props: true,
					meta: {
						title: 'User Profile',
						origin: [{ name: 'users', text: 'Users' }]
					}
				},

				{
					path: '/notification-post',
					name: 'notification-post',
					component: NotificationPost,
					meta: {
						title: 'Notification Posts'
					}
				},

				{
					path: '/notification-post/create',
					name: 'create-notification',
					component: NotificationCreate,
					meta: {
						title: 'Create Notification',
						origin: [{ name: 'notification-post', text: 'Notification Posts' }]
					}
				},

				{
					path: '/notification-post/edit/:notificationId',
					name: 'edit-notification',
					component: NotificationEdit,
					props: true,
					meta: {
						title: 'Edit Notification',
						origin: [{ name: 'notification-post', text: 'Notification Posts' }]
					}
				},

				{
					path: '/newsfeed-post',
					name: 'newsfeed-post',
					component: NewsfeedPost,
					meta: {
						title: 'Newsfeed Posts'
					}
				},

				{
					path: '/newsfeed-post/create',
					name: 'create-newsfeed',
					component: NewsfeedCreate,
					meta: {
						title: 'Create Newsfeed',
						origin: [{ name: 'newsfeed-post', text: 'Newsfeed Posts' }]
					}
				},

				{
					path: '/newsfeed-post/edit',
					name: 'edit-newsfeed',
					component: NewsfeedEdit,
					meta: {
						title: 'Edit Newsfeed',
						origin: [{ name: 'newsfeed-post', text: 'Newsfeed Posts' }]
					}
				},

				{
					path: '/newsfeed-post/main',
					name: 'newsfeed-post-main',
					component: NewsfeedPost,
					meta: {
						title: 'Newsfeed Posts'
					}
				},

				{
					path: '/newsfeed-post/mid',
					name: 'newsfeed-post-mid',
					component: NewsfeedPost,
					meta: {
						title: 'Newsfeed Posts'
					}
				},

				{
					path: '/newsfeed-post/subtags',
					name: 'newsfeed-post-subtags',
					component: NewsfeedPost,
					meta: {
						title: 'Newsfeed Posts'
					}
				},

				{
					path: '/newsfeed-post/drafts',
					name: 'newsfeed-post-drafts',
					component: NewsfeedPost,
					meta: {
						title: 'Newsfeed Posts'
					}
				},

				{
					path: '/newsfeed-post/archives',
					name: 'newsfeed-post-archives',
					component: NewsfeedPost,
					meta: {
						title: 'Newsfeed Posts'
					}
				},

				{
					path: '/newsfeed-post/add-subtags',
					name: 'newsfeed-post-add-subtags',
					component: AddSubtags,
					meta: {
						title: 'Add Subtags'
					}
				},

				{
					path: '/orders',
					name: 'orders',
					component: Orders,
					meta: {
						title: 'Orders'
					}
				},

				{
					path: '/order/:id',
					name: 'order',
					component: Order,
					props: true,
					meta: {
						title: 'Order',
						origin: [{ name: 'orders', text: 'Orders' }]
					}
				},

				{
					path: '/stickers',
					name: 'stickers',
					component: Stickers,
					meta: {
						title: 'Stickers'
					}
				},
				{
					path: '/stickers/:name',
					name: 'view-stickers',
					component: StickersView,
					props: true,
					meta: {
						title: 'View Stickers',
						origin: [{ name: 'stickers', text: 'Sticker' }]
					}
				},
				{
					path: '/sticker/add-stickers',
					name: 'add-stickers',
					component: StickersAdd,
					meta: {
						title: 'Add Stickers',
						origin: [{ name: 'stickers', text: 'Sticker' }]
					}
				},

				{
					path: '/sticker/:name/update',
					name: 'stickers-update',
					component: StickersUpdate,
					meta: {
						title: 'Update Stickers',
						origin: [{ name: 'stickers', text: 'Sticker' }]
					}
				},

				{
					path: '/messages',
					name: 'messages',
					component: Messages,
					meta: {
						title: 'Messages'
					}
				}
			]
		},

		{
			path: '/generate-report',
			name: 'generate-report',
			component: GenerateReport
		}
	])
]

function middleware (middleware, routes) {
	routes.forEach(route =>
		(route.middleware || (route.middleware = [])).unshift(middleware)
	)

	return routes
}
